import React, { useState, useEffect } from "react";
import { Form, Modal, Tab } from "semantic-ui-react";
import { useFormik } from "formik";
import { Syllabu, Subject, Grade, Level } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  initialValues,
  validationSchema,
} from "./SyllabuSubjectGradeForm.form";
import { ListSyllabuSubjectGrade } from "../ListSyllabuSubjectGrade";
import { withEmptyOption } from "../../../../utils";
import "./SyllabuSubjectGradeForm.scss";

const syllabuController = new Syllabu();
const gradeController = new Grade();
const levelController = new Level();

export function SyllabuSubjectGradeForm(props) {
  const { syllabu } = props;
  const { accessToken } = useAuth();
  const [reload, setReload] = useState(false);

  const [subjectsOptions, setSubjectsOptions] = useState([]);
  const [gradesOptions, setGradesOptions] = useState([]);
  const [levelsOptions, setLevelsOptions] = useState([]);
  const [levelId, setLevelId] = useState("");
  const [syllabuSubjectGrades, setSyllabuSubjectGrades] = useState(null);
  const onReload = () => setReload((prevState) => !prevState);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          syllabuId: syllabu.id,
          subjectId: formValue.subjectId,
          gradeId: formValue.gradeId,
        };
        await syllabuController.createSyllabuSubjectGrade(accessToken, data);
        formik.values.subjectId = null;
        onReload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await levelController.getLevels(accessToken);
        const options = response.map((level) => ({
          value: level.id,
          text: level.name,
        }));
        setLevelsOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [syllabu, accessToken]);

  useEffect(() => {
    (async () => {
      try {
        setGradesOptions([]);
        formik.setFieldValue("gradeId", "");
        formik.setFieldValue("subjectId", null);
        setSyllabuSubjectGrades(null);
        if (!levelId) return;
        const response = await gradeController.getGradesByLevelId(levelId, accessToken);
        const options = response.map((grade) => ({
          value: grade.id,
          text: grade.name,
        }));
        setGradesOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [levelId, accessToken]);

  useEffect(() => {
    (async () => {
      try {
        if (formik.values.gradeId) {
          setSubjectsOptions([]);
          setSyllabuSubjectGrades(false);
          const response = formik.values.gradeId
            ? await syllabuController.getSyllabuSubjectGrades(
                accessToken,
                syllabu.id,
                formik.values.gradeId
              )
            : null;
          const availableSubjectsOptions = response.availableSubjects.map(
            (subject) => ({
              value: subject.id,
              text: subject.name,
            })
          );
          setSubjectsOptions(availableSubjectsOptions);
          setSyllabuSubjectGrades(response.assignedSubjects);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, syllabu, formik.values.gradeId, accessToken]);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListSyllabuSubjectGrade
            syllabuSubjectGrades={syllabuSubjectGrades}
            gradeId={formik.values.gradeId}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <Form
        className="syllabu-subject-grade__form"
        onSubmit={formik.handleSubmit}
      >
        <div className="custom-form-group">
          <div className="select-field">
            <Form.Select
              className="edunova-select"
              name="levelId"
              label="Nivel"
              placeholder="Selecciona un nivel"
              clearable
              options={withEmptyOption(levelsOptions, "Selecciona un nivel")}
              onChange={(e, { value }) => setLevelId(value || "")}
              value={levelId}
            />
          </div>
          <div className="select-field">
            <Form.Select
              className="edunova-select"
              name="gradeId"
              label="Grado"
              placeholder="Selecciona un grado"
              clearable
              options={withEmptyOption(gradesOptions, "Selecciona un grado")}
              disabled={!levelId}
              onChange={(e, { value }) => {
                formik.setFieldValue("gradeId", value);
                formik.setFieldValue("subjectId", null);
              }}
              value={formik.values.gradeId}
              error={formik.errors.gradeId}
            />
          </div>
          <div className="select-field">
            <Form.Select
              className="edunova-select"
              name="subjectId"
              label="Asignatura"
              placeholder="Selecciona una asignatua"
              clearable
              options={withEmptyOption(subjectsOptions, "Selecciona una asignatua")}
              onChange={(e, { value }) =>
                formik.setFieldValue("subjectId", value)
              }
              value={formik.values.subjectId}
              error={formik.errors.subjectId}
            />
          </div>
          <div className="button-field">
            <div className="label-space"></div>
            <Form.Button
              type="submit"
              primary
              fluid
              loading={formik.isSubmitting}
            >
              Agregar asignatura y grado
            </Form.Button>
          </div>
        </div>
      </Form>
      <Modal.Content scrolling className="syllabu-subject-grade__scroll">
        <Tab className="syllaby-subject-grade__list" panes={panes} />
      </Modal.Content>
    </>
  );
}
